<template>
  <div class="main-app" style="height: auto">
    <Loader v-if="$store.state.loader" />
    <div class="container">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import Loader from "../../../components/Loaders/loaderCarga.vue";

export default {
  props: ["propiedad_id"],
  components: {
    Loader,
  },
  async mounted() {
    this.$store.state.loader = true;
    try{
     await this.getProperty(this.propiedad_id);
    }catch(error){
       toastr.error("Error load property");
    }
    finally{
      this.$store.state.loader = false;
    }
    
  },
  data() {
    return {
      propiedad: null,
    };
  },
  methods: {
    ...mapActions('property',['getProperty']),
  },
};
</script>
<style lang="scss">
/*
 * Tipografia del web del huesped: DM Sans, la de la casa.
 *
 * Estas pantallas salian en Inter porque App.scss lo fija con `!important`
 * sobre body/a/p/h4-h6/small/label. La primera regla basta para todo lo que
 * hereda —titulos, spans, botones—; la segunda existe solo para ganarle a ese
 * `!important` en las siete etiquetas que lo llevan. No se toca `*` a proposito:
 * los iconos (Font Awesome, PrimeIcons) tienen su propia familia y se romperian.
 */
.main-app {
  font-family: "DM Sans", system-ui, sans-serif;
}
.main-app a,
.main-app p,
.main-app h4,
.main-app h5,
.main-app h6,
.main-app small,
.main-app label {
  font-family: "DM Sans", system-ui, sans-serif !important;
}

.header img {
  width: 150px;
  margin: auto;
  display: block;
  margin-top: 13px;
  padding-bottom: 10px;
}
</style>
